import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Wallet } from 'lucide-react';
import ShippingPoolWalletPanel from '../../components/vendor/ShippingPoolWalletPanel';

/**
 * VendorWalletLedger — iter-230bv (body extracted to
 * `ShippingPoolWalletPanel` in iter-379 so the Payouts page's new
 * "Wallet" tab can reuse the exact same summary + ledger UI).
 *
 * Full-page ledger view of the vendor's shipping-pool wallet history.
 */
export default function VendorWalletLedger() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-50">
      <header className="bg-white border-b border-zinc-200 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 flex items-center gap-3">
          <button
            data-testid="wallet-ledger-back"
            type="button"
            onClick={() => navigate(-1)}
            className="p-2 -ml-2 rounded-lg hover:bg-zinc-100"
          >
            <ArrowLeft className="w-5 h-5 text-zinc-700" />
          </button>
          <div className="flex items-center gap-2">
            <Wallet className="w-5 h-5 text-emerald-600" />
            <h1 className="text-lg font-semibold text-zinc-900">
              Shipping Pool Wallet
            </h1>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto p-4 sm:p-6">
        <ShippingPoolWalletPanel />
      </main>
    </div>
  );
}

